<template>
  <div class="strategys-time-content" v-loading="loading">
    <div class="con-table">
      <div class="control-group">
        <div class="group-tip">根据您设置的时间策略，绑定到路灯上，路灯定时开关灯和调光</div>
        <div class="group-left">
          <el-button
            type="primary"
            size="small"
            @click="openEditWin('create')"
            class="insert-btn"
            ><svg-icon name="add-plus"></svg-icon>新建策略</el-button
          >
        </div>
      </div>
      <div class="h20"></div>
      <table class="diy-table">
        <thead>
          <tr>
            <th width="280"><div class="cell">策略名称</div></th>
            <th><div class="cell times">开始时间<div class="icon"><svg-icon name="between"/></div>结束时间</div></th>
            <th width="250"><div class="cell">亮度</div></th>
            <th width="250"><div class="cell">操作</div></th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(item,index) in tableData">
              
            <tr class="double0">
              <td><div class="cell">{{item.title}}</div></td>
              <td>
                <div v-if="item.stg_list.length" class="cell times">
                  <div class="time1"><span class="w-label">　</span> {{ item.stg_list[0].time[0] }}</div>
                  <div class="icon"><svg-icon name="between"/></div>
                  <div class="time2">{{ item.stg_list[0].time[1] }}</div>
                </div>
                <div v-else class="cell">-</div>
              </td>
              <td>
                <div v-if="item.stg_list.length" class="cell">{{ item.stg_list[0].light }}%</div>
                <div v-else class="cell">-</div>
              </td>
              <td>
                <div class="cell">
                  <div class="table-last normal">
                    <span @click="(loading = true), openEditWin(item)" class="blue pointer mar-r15">编辑</span>
                    <span @click="delItem(item.id)" class="blue pointer">删除</span>
                  </div>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>

    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageInfo.page"
      :page-sizes="[10, 20, 30, 40, 50, 100]"
      :page-size="pageInfo.pageSize"
      layout="sizes, total, prev, pager, next, jumper"
      :total="cnt_all"
    >
    </el-pagination>
    

    <!--新增修改路灯策略 开始-->
    <el-dialog
      v-if="dialogVisible"
      class="normal_dialog dialog860"
      :title="editType === 'create' ? '新增策略' : '编辑策略'"
      :visible.sync="dialogVisible"
    >
      <el-form
        :model="editOne"
        ref="editOneRef"
        :rules="editOneRule"
      >
        <div class="form-info">
          <el-row :gutter="20" class="item-list">
            <el-col :span="12">
              <el-form-item label="策略名称" prop="title">
                <el-input v-model="editOne.title" placeholder="请输入策略名称"></el-input>
              </el-form-item>
            </el-col>
      
          </el-row>

          <div class="insert-strategy">
            <div class="sub-title">时间表</div>
            <ul class="t-head">
              <li>编号</li>
              <!-- <li>灯号</li> -->
              <li class="times">开始时间<div class="icon"><svg-icon name="between"/></div>结束时间</li>
              <li>亮度(%)</li>
              <li>操作</li>
            </ul>
            <div v-for="(item,index) in editOne.stg_list" :key="item.key" class="item-box">
              <div class="item">
                <div class="bh">{{toOrder(index+1)}}</div>
                <!-- <div class="number">灯</div> -->
                <div class="lamp-time">
                  <div class="line">
                    <el-time-picker
                      :name="'picker'+item.key"
                      :clearable="false"
                      is-range
                      v-model="item.time"
                      format='HH:mm'
                      start-placeholder="任意时间点"
                      end-placeholder="任意时间点"
                      placeholder="选择开关灯时间"
                      style="width: 100%"
                    >
                    </el-time-picker>
                  </div>
                </div>
                <div class="lamp-light">
                  <div class="line">
                    <el-input-number
                      controls-position="right"
                      v-model="item.light"
                      :min="0"
                      :max="100"
                      class="strategy_number"
                    >
                    </el-input-number>
                  </div>
                </div>
                <div class="addDel">
                  <div class="item-btn" @click="removeTime(index)"><i class="el-icon-remove"></i></div>
                  <div class="item-btn" @click="addTime"><i class="el-icon-circle-plus"></i></div>
                </div>
              </div>
            </div>

          </div>
      
          <div class="lamp-transfer strategy-transfer">
            <el-transfer
              filterable
              filter-placeholder="请输入路灯别名或序列号"
              :data="allDevices"
              :titles="['可选路灯', '已选路灯']"
              :button-texts="['删除到可选', '添加到已选']"
              v-model="allocated"
            >
            </el-transfer>
          </div>

        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <div class="box-footer">
          <el-button class="cancel-btn" size="medium" @click="dialogVisible = false">取消</el-button>
          <el-button v-if="editType === 'create'" type="primary" size="medium" @click="createItem">确定</el-button>
          <el-button v-if="editType === 'update'" type="primary" size="medium" @click="updateItem">确定</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 新增修改路灯策略 结束 -->
  </div>
</template>
<script>
import time from "@/utils/time";
import moment from "moment";
import strategyApi from "@/api/light/strategy"
export default {
  name: "strategyTime",
  props:['stgId'],
  data() {
    return {
      loading: false,
      tableData: [],
      pageInfo: {
        strategy_type: 1,
        page: 1,
        pageSize: 10,
      },
      cnt_all: 0,
      dialogVisible: false,
      editOneRule: {
        title: [{ required: true, message: "请输入策略名称", trigger: "blur" }]
      },
      editType: -1,
      editOne: {
        id: '',
        title: '',
        strategy_type: 1,
        stg_list: [
          {
            key: Date.now(),
            light: 0,
            time: [this.numberToTime(0), this.numberToTime(3600)],
            time2: [this.numberToTime(0), this.numberToTime(3600)]
          }
        ]
      },
      allDevices: [],
      allocated: []
    };
  },
  mounted() {
    this.getTableData(this.pageInfo.page)
    if(this.stgId){
      this.strategyInfo(this.stgId)
    }
  },
  methods: {
    ...time,
    getTableData(pageIndex) {
      this.pageInfo.page = pageIndex
      this.loading = true
      this.tableData = []
      strategyApi.strategyList(this.pageInfo).then((res) => {
        if (res.data.code === 1000) {
          this.loading = false;
          let resData = res.data.data;
          this.tableData = resData.list;
          this.pageInfo.page = pageIndex;
          this.cnt_all = parseInt(resData.count);
        }
      })
    },
    strategyInfo(stgId) {
      strategyApi.getStrategyInfo(stgId).then((res) => {
        console.log('strategyInfo',res)
        if (res.data.code === 1000) {
          let index = res.data.data
          if(index.id){
            this.editOne = {
              id: index.id,
              title: index.title,
              strategy_type: 1,
              stg_list: []
            };
            this.editType = "update";
            this.getStgTime(index.id,index.is_double,index.stg_list)
            this.getLampList('');
            this.dialogVisible = true;
            this.loading = false;
          }
        }
      })
    },
    handleSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getTableData(this.pageInfo.page);
    },
    handleCurrentChange(val) {
      this.pageInfo.page = val;
      this.getTableData(this.pageInfo.page);
    },
    openEditWin(index) {
      this.allDevices = []
      this.allocated = []
      if (index === "create") {
        this.editOne = {
          id: '',
          title: '',
          strategy_type: 1,
          stg_list: [
            {
              key: Date.now(),
              light: 0,
              time: [this.numberToTime(0), this.numberToTime(3600)],
              time2: [this.numberToTime(0), this.numberToTime(3600)]
            }
          ]
        };
        this.editType = "create";
        this.dialogVisible = true;
        this.loading = false;
      } else {
        this.editOne = {
          id: index.id,
          title: index.title,
          strategy_type: 1,
          stg_list: []
        };
        this.editType = "update";
        this.getStgTime(index.id,index.stg_list)
        setTimeout(() => {
          this.dialogVisible = true;
          this.loading = false;
        }, 800)
      }
      this.getLampList('');
    },
    getStgTime(id,arr) {
      for (let i=0; i<arr.length; i++) {
        let time2 = []
        let item_one = {
          key: parseInt(id+'0'+i),
          time: [this.numberToTime(this.HmToNumber(arr[i].time[0])), this.numberToTime(this.HmToNumber(arr[i].time[1]))],
          time2: time2,
          light: parseInt(arr[i].light)
        }
        this.$set(this.editOne.stg_list, i, item_one)
      }
    },
    addTime() {
      this.editOne.stg_list.push({
        key: Date.now(),
        light: 0,
        time: [this.numberToTime(0), this.numberToTime(3600)],
        time2: [this.numberToTime(0), this.numberToTime(3600)]
      });
    },
    removeTime(index) {
      if(this.editOne.stg_list.length<=1){
        return this.$message.error('策略时间表至少存在一条！');
      }
      if (confirm("确定要删除这个时间段？")) {
        this.editOne.stg_list.splice(index, 1);
      }
    },
    createItem() {
      this.$refs.editOneRef.validate((valid) => {
        if (valid) {
          let stg_list = this.editOne.stg_list
          if(stg_list.length<1){
            return this.$message.error('策略时间表至少存在一条！');
          }

          let params = {
            title: this.editOne.title,
            strategy_type: 1,
            stg_list: [],
            ids: ''
          }

          if(this.allocated.length){
            params.ids=this.allocated.toString();
          }

          let newStg_list= []
          for(let i =0; i<stg_list.length; i++){
            let item_one = {
              light: stg_list[i].light,
              time: [moment(stg_list[i].time[0]).format("HH:mm"),moment(stg_list[i].time[1]).format("HH:mm")],
              time2: [moment(stg_list[i].time2[0]).format("HH:mm"),moment(stg_list[i].time2[1]).format("HH:mm")],
            }
            newStg_list[i] = item_one
          }
          params.stg_list = JSON.stringify(newStg_list);
          strategyApi.strategyAdd(params).then((res) => {
            if (res.data.code === 1000) {
              this.$message.success("添加成功");
              this.dialogVisible = false;
              this.getTableData(this.pageInfo.page);
            } else {
              this.$message.error(res.data.message);
            }
          })
        } else {
          return false
        }
      })

    },
    updateItem() {
      this.$refs.editOneRef.validate((valid) => {
        if (valid) {
          let stg_list = this.editOne.stg_list
          if(stg_list.length<1){
            return this.$message.error('策略时间表至少存在一条！');
          }
          let params = {
            id: this.editOne.id,
            title: this.editOne.title,
            strategy_type: 1,
            stg_list: [],
            ids: ''
          }

          if(this.allocated.length){
            params.ids=this.allocated.toString();
          }

          let newStg_list= []
          for(let i =0; i<stg_list.length; i++){
            let item_one = {
              light: stg_list[i].light,
              time: [moment(stg_list[i].time[0]).format("HH:mm"),moment(stg_list[i].time[1]).format("HH:mm")],
              time2: [moment(stg_list[i].time2[0]).format("HH:mm"),moment(stg_list[i].time2[1]).format("HH:mm")],
            }
            newStg_list[i] = item_one
          }
          params.stg_list = JSON.stringify(newStg_list);
          strategyApi.strategyEdit(this.editOne.id,params).then((res) => {
            if (res.data.code === 1000) {
              this.$message.success("修改成功")
              this.dialogVisible = false;
              this.getTableData(this.pageInfo.page);
            } else {
              this.$message.error(res.data.message)
            }
          })
        } else {
          return false
        }
      })
    },  
    getLampList(id) {
      let that = this
      strategyApi.getStrategyList({
        id: id,
        page: 1,
        pageSize: 1000
      }).then((res) => {
        if (res.data.code === 1000) {
          let arrData = []
          let resData = res.data.data
          if(resData.length){
            for (const lamp of resData) {
              arrData.push({
                key: lamp.id+'_'+lamp.type,
                label: lamp.name+'-'+lamp.number
              })
            }
          }
          that.allocated = []
          if(id){
            if(arrData.length){
              for (const item of arrData) {
                that.allocated.push(item.key)
              }
              that.allDevices = [...that.allDevices, ...arrData]
              that.allDevices = Array.from(new Set(that.allDevices))
            }
          }else{
            that.allDevices = arrData
            if(that.editOne.id){
              that.getLampList(that.editOne.id)
            }
          }
        }
      })
    },

    delItem(id) {
      this.$confirm("本操作将永久删除该条信息，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          strategyApi.strategyDel(id).then((res) => {
            if (res.data.code === 1000) {
              this.$popupMessage({
                type: 'success',
                title: "删除成功"
                // msg: '如果未刷新，请耐心等待5秒，点击刷新列表查看结果'
              })
              this.getTableData(this.pageInfo.page);
            } else {
              this.$popupMessage({
                type: 'error',
                title: "提示",
                msg: res.data.message,
              })
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    getValue(value) {
      if (value == "1"||value == 1) {
        return "双灯模式";
      } else {
        return "单灯模式";
      }
    },
    toOrder(index){
      if(index<10){
        return '0'+index
      }else{
        return index
      }
    }
  }
  
};
</script>

<style lang='less'>
.strategys-time-content{
  padding:0 0 20px;
  .con-table{
    padding-bottom: 20px;
  }
  .diy-table{
    width:100%;
    border: 0;
    border-collapse: collapse;
    border-spacing: 0;
    color: #1d2129;
    tr{
      margin:0;
      padding: 0;
      border: 0;
      th,td{
        border: 0;
        border-right: 1px solid #dee0e4;
        border-bottom: 1px solid #dee0e4;
        padding: 20px 0;
        min-width: 0;
        word-break: break-all;
        box-sizing: border-box;
        text-overflow: ellipsis;
        vertical-align: middle;
        position: relative;
        background-clip: padding-box; /* Add this line */
        .cell{
          box-sizing: border-box;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: normal;
          word-break: break-all;
          line-height: 1.4;
          padding:5px 10px;
          font-size: 14px;
          text-align: center;
          &.times{
            display: flex;
            align-items: center;
            justify-content: center;
            .icon{
              margin: 0 20px;
              font-weight: normal;
            }
          }
        }
        &:last-child{
          border-right: 1px solid transparent;
        }
      }
      
      th{
        background-color: #f5f7f9;
        border-right: 1px solid #f5f7f9;
        border-bottom: 1px solid #dee0e4;
        .cell{
          font-size: 16px;
          font-weight: bold;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }

      td{
        .time1{
          width:140px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .time2{
          width:140px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .icon{
          color:#bbb;
        }
      }

      
      &.sub-tr{
        td{
          &:last-child{
            border-right: 1px solid #dee0e4;
          }
        }
      }
      &.double0{
        td{
          background-color: rgba(246,255,255,.6);
        }
      }
    }
  }
  .insert-strategy{
    color:#1d2129;
    padding-bottom: 20px;
    .sub-title{
      padding-bottom: 15px;
    }
    .t-head{
      width:100%;
      margin: 0;
      padding: 0;
      display: flex;
      align-items: center;
      background-color: #f6f7fb;
      li{
        height:40px;
        display: flex;
        align-items: center;
        justify-content: center;
        width:60px;
        &:nth-child(2){
          flex: 1;
          min-width: 300px;
        }
        &:nth-child(3),&:nth-child(4){
          width:150px;
        }
        &.times{
          display: flex;
          align-items: center;
          justify-content: center;
          .icon{
            margin: 0 20px;
            font-weight: normal;
          }
        }
      }
    }
    .item-box{
      width:100%;
      border-bottom: 1px solid #dcdee2;
      .item{
        height:40px;
        display: flex;
        .bh,.number,.lamp-time,.lamp-light,.addDel{
          width:60px;
          height:40px;
          border-right:1px solid #dcdee2;
          display:flex;
          align-items:center;
          justify-content:center;
        }
        &.double{
          height:81px;
          .bh,.number,.lamp-time,.lamp-light,.addDel{
            height:81px;
            flex-direction: column;
            .line{
              width:100%;
              height:50%;
              display:flex;
              align-items:center;
              justify-content:center;
              box-sizing: border-box;
              overflow: hidden;
              &:last-child{
                border-top:1px solid #dcdee2;
              }
            }
          }
          .addDel{
            flex-direction: row;
          }

        }

        .lamp-time{
          flex: 1;
          min-width: 260px;
          .line{
            position:relative;
            z-index: 3;
          }
        }
        .lamp-light{
          width:150px;
        }
        .addDel{
          width:150px;
          border-right-color:#ffffff;
          .item-btn{
            width:25px;
            height:25px;
            color:#2d8cf0;
            font-size:22px;
            display:flex;
            align-items:center;
            justify-content:center;
            cursor:pointer;
            margin:0 8px;
          }
        }
      }
    }
  }
  
}

.lamp-time{
  .el-input__inner{
    border:0;
    display:flex;
    align-items:center;
    justify-content: center;
    position:relative;
    .el-icon-time,.el-range__close-icon{
      position:absolute;
      right:10px;
      top:50%;
      transform: translateY(-50%);
    }
    .el-range-input{
      font-size:14px;
      font-family:arial;
      color:#111;
      width:28%;
    }
    
    .el-range__close-icon{
      right:35px;
    }
    .el-range-separator{
      width:45px;
      height:34px;
      text-indent:-2222em;
      position:relative;
      &::after{
        content: '';
        width:16px;
        height:5px;
        position:absolute;
        top:50%;
        margin-left:-8px;
        left:50%;
        margin-top:-2.5px;
        background: url(../../../assets/images/between.png) center center no-repeat;
        background-size: 100% 100%;
      }
    }
  }
}
.strategy_number{
  position:relative;
  width:100%;
  height:40px;
  .el-input__inner{
    border:0;
    font-size:14px;
    font-family:arial;
    color:#111;
  }
  .el-input-number__decrease,.el-input-number__increase{
    width:28px !important;
    height:20px !important;
    border-top:0 !important;
    box-sizing:border-box;
    right:0 !important;
    display:flex;
    align-items:center;
    justify-content:center;
    background: none !important;
    font-size:16px;
    top:0 !important;
    z-index: 9999;
  }
  .el-input-number__decrease{
    top: auto !important;
    bottom:0 !important;
  }
}

.strategy-transfer{
  .el-transfer__buttons{
    .el-transfer__button{
      left:100px !important;
      &:first-child{
        left: auto !important;
        right:100px !important;
      }
    }
  }
}

.w-label{
  width:50px;
  text-align: right;
  display: block;
}
</style>
